export class PaymentRequest{
    id?: string;
    paymentMethod?: string;
    amount?: string;
    status?: string;
    transactionId?: string;
    createdAt?: string;
    updatedAt?: string;
    categoryId?: string;
    athleteId?: string;
    intentPaymentStatus?: string;

    constructor(raw?: PaymentRequest) {
        if (raw){
            this.id = raw.id;
            this.paymentMethod = raw.paymentMethod;
            this.amount = raw.amount;
            this.status = raw.status;
            this.transactionId = raw.transactionId;
            this.createdAt = raw.createdAt;
            this.updatedAt = raw.updatedAt;
            this.categoryId = raw.categoryId;
            this.athleteId = raw.athleteId;
            this.intentPaymentStatus = raw.intentPaymentStatus;
        }
    }

}
